import React, { FC } from 'react';
import { User } from '../../../config/api/models/User';
import { getInitials } from '../index';
import { GroupStudent } from '../../../config/api/models/Group';
import { Theme, styled } from '@material-ui/core';

export type ProfilePictureSize = 'small' | 'medium' | 'large';

export type ProfilePictureProps = {
  user?: User | GroupStudent;
  initials?: string;
  size?: ProfilePictureSize;
  className?: string;
};

const StyledProfilePicture = styled('div')<Theme>(({ theme }) => ({
  display: 'grid',
  placeItems: 'center',
  width: '3rem',
  height: '3rem',
  borderRadius: '100%',
  background: theme.palette.primary.main,
  aspectRatio: '1 / 1',
  '&.large': {
    width: '7.4rem',
    height: '7.4rem',
  },
  '&.small': {
    width: '2.4rem',
    height: '2.4rem',
  },
}));

const StyledUserInitials = styled('div')<Theme>(({ theme }) => ({
  fontFamily: theme.config.secondaryFontFamily,
  fontWeight: 700,
  fontSize: '1.4rem',
  textTransform: 'uppercase',
  color: theme.palette.common.white,
  '&.large': {
    fontSize: '2.8rem',
  },
  '&.small': {
    fontSize: '1.1rem',
  },
}));

const ProfilePicture: FC<ProfilePictureProps> = ({
  user,
  initials,
  size = 'medium',
  className,
}) => (
  <StyledProfilePicture className={`${className} ${size}`}>
    <StyledUserInitials className={size} data-testid="dm-profilepicture-initials">
      {user ? getInitials(user) : initials}
    </StyledUserInitials>
  </StyledProfilePicture>
);

export default ProfilePicture;
